export default __webpack_public_path__ + "static/article-top-cars-under-40k-0b1e9450a4eb80c2bf192163c0556d50.jpg";